import React from "react";
import { twMerge } from "tailwind-merge";

export const DashboardContent: React.FC<{
  Header?: React.ReactNode;
  children?: React.ReactNode;
  sidebar?: React.ReactNode;
  removePadding?: boolean;
}> = ({ Header, sidebar, children, removePadding }) => (
  <div className="flex max-h-screen min-h-0 max-w-full grow flex-col justify-stretch">
    {Header}
    <div className="flex max-h-full min-h-0 w-full max-w-full flex-1 overflow-clip">
      {sidebar}
      <div
        className={twMerge(
          "flex max-h-full min-h-0 w-full max-w-full flex-1 flex-col overflow-auto bg-gray-100",
          !removePadding && "p-5",
        )}
      >
        {children}
      </div>
    </div>
  </div>
);
